import { Injectable } from '@angular/core';
import { EnergyType, VehicleType } from 'src/swagger-gen/web-secured/models';
import {PaymentType} from '../../swagger-gen/web-public/models/payment-type';

@Injectable({
  providedIn: 'root',
})
export class StationService {
  constructor() {}

  readonly ENDPOINT_ELECTRICITY = 'electrical';

  /**
   * Convert Electricity Station type to endpoint electrical
   * @param eType Station Type
   * @returns associated endpoint for each station type
   */
  convertElecTypeToEndpoint(eType: string): string {
    let type: string;
    if (
      eType === EnergyType.ELECTRICITY ||
      eType === EnergyType.ELECTRICITY.toLowerCase()
    ) {
      type = this.ENDPOINT_ELECTRICITY;
    } else {
      type = eType.toLowerCase();
    }
    return type;
  }

  /**
   * Set icon for vehicle
   * @param vehicle Authorized Vehicles
   * @returns fontawesome class string
   */
  setVehicleIcon(vehicle: string) {
    if (vehicle === VehicleType.BIKE) {
      return 'fas fa-ship';
    } else if (vehicle === VehicleType.GARBAGE_TRUCK) {
      return 'fas fa-ship';
    } else if (vehicle === VehicleType.HEAVY) {
      return 'fas fa-ship';
    } else if (vehicle === VehicleType.HEAVY_WITH_TRAILER) {
      return 'fas fa-ship';
    } else if (vehicle === VehicleType.LIGHT) {
      return 'fas fa-ship';
    } else if (vehicle === VehicleType.BUS) {
      return 'fas fa-ship';
    }
  }
  setPaymentIcon(payment: string, stationList: boolean) {
    const basePath = stationList ? '../../../../../../public/images/payment/list/ico-' : '../../../../../../public/images/payment/map/';
    if (payment === PaymentType.UTA) {
      return basePath + 'uta.png';
    } else if (payment === PaymentType.AS24) {
      return basePath + 'as24.png';
    } else if (payment === PaymentType.AXEGAZ) {
      return basePath + 'axegaz.png';
    } else if (payment === PaymentType.BADGE) {
      return basePath + 'badge.png';
    } else if (payment === PaymentType.BANK_CARD) {
      return basePath + 'cb.png';
    } else if (payment === PaymentType.DKV) {
      return basePath + 'dkv.png';
    } else if (payment === PaymentType.ENGIE_CARD) {
      return basePath + 'engie.png';
    } else if (payment === PaymentType.LICENSE_PLATE) {
      return basePath + 'immatriculation.png';
    } else if (payment === PaymentType.SMARTPHONE) {
      return basePath + 'smartphone.png';
    } else if (payment === PaymentType.OTHER) {
      return basePath + 'autre.png';
    }
  }
  convertSecondsToHhMmSs(timeStr: string) {
    const time = Number(timeStr);
    // Hours, minutes and seconds
    const hrs = ~~(time / 3600);
    const mins = ~~((time % 3600) / 60);
    const secs = ~~time % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    let ret = '';
    if (hrs > 0) {
      ret += '' + hrs + 'h ' + (mins < 10 ? '0' : '');
    }
    ret += '' + mins + 'm ' + (secs < 10 ? '0' : '');
    ret += '' + secs + 's';
    return ret;
  }
}
